import { parseClientEnv, type ClientEnv } from './env.schema';

/**
 * The validated client environment.
 *
 * `vite.config.ts` runs the same schema over the resolved `.env` files before a
 * single module is transformed, so a missing or malformed value fails the build
 * rather than reaching a browser. This module is the second half of that
 * arrangement: it re-parses at module-evaluation time so the values the
 * application reads are typed and non-optional, instead of the
 * `string | undefined` that `import.meta.env` hands out.
 *
 * Import `env`, never `import.meta.env`.
 */
export const env: ClientEnv = parseClientEnv(
  import.meta.env as unknown as Record<string, unknown>,
);

export type { ClientEnv };
